import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';

export interface CurrentUserDetails {
    id: string;
    email: string;
    fullName: string;
    firstProjectId: string | null;
}

const currentUserApi = createApi({
    reducerPath: 'lokaliseInternal_currentUser',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['currentUser'],
    endpoints: (builder) => ({
        getCurrentUser: builder.query<CurrentUserDetails, void>({
            query: () => ({ method: 'GET', url: '/current-user' }),
            providesTags: ['currentUser'],
        }),
    }),
});

export default currentUserApi;
